import React,{useState,useEffect} from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";
import { getActivePrice } from "../../utils/converter";
import Cart from "../../assets/img/core-img/cart.png"


const Products = ({products}:any) => {

  const navigate = useNavigate();


  return (
    <div className="row">
 {products?.map((d: any, index: number) => (

    <div className="col-12 col-sm-6 col-md-12 col-xl-6" key={index} >
        <div className="single-product-wrapper" >
            <div className="product-img" onClick={() => navigate(`/shop/${d?.product}/${d?._id}`)}>
                <img src={d?.images[0]} alt=""/>
                {/* <img className="hover-img" src="img/product-img/product2.jpg" alt=""> */}
            </div>

            <div className="product-description d-flex align-items-center justify-content-between">
                <div className="product-meta-data">
                    <div className="line"></div>
                    <p className="product-price">{`RWF ${getActivePrice(d?.prices)?.toLocaleString()}`}</p>
                    <a href="#">
                        <h6>{d?.product}</h6>
                    </a>
                </div>
                <div className="ratings-cart text-right">
                    <div className="ratings">
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                    </div>
                    {/* <div className="cart" >
                     <a href="#" data-toggle="tooltip" data-placement="left" title="Add to Cart" onClick={() => handleAddToCart(d?._id)}>{isLoading ? (<small>saving...</small>): (<img src={Cart} alt="" />)}</a>
                    </div> */}
                </div>
            </div>
        </div>
    </div>

    ))}

    </div>

   
  );
};

export default Products;
